import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.iconGroup}>
        <a
          href="https://www.instagram.com/nextstudentagency/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram: @nextstudentagency"
          className={styles.iconLink}
        >
          <div className={styles.instagramIcon}>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="48" 
              height="48" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </div>
        </a>
        <a
          href="https://www.linkedin.com/company/106208910/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn: Next Student Agency"
          className={styles.iconLink}
        >
          <div className={styles.linkedinIcon}></div>
        </a>
      </div>
      <div className={styles.footerEmail}><a href="mailto:NEXT@humber.ca" target="_blank" rel="noopener noreferrer">Email Me</a></div>
    </footer>
  );
};

export default Footer; 